module.exports = __webpack_public_path__ + "static/media/full_width_version_desktop.ef183276.jpg";